const $registrationForm = document.querySelector('#reg-form')

if ($registrationForm) {
    registrationForm($registrationForm)
}

function registrationForm($wrapper) {
    const $isCompany = $wrapper.querySelector('#reg-form-is-company')
    const $isES = $wrapper.querySelector('#reg-form-is-ES')
    const $countryWrapper = $wrapper.querySelector('#reg-form-country-wrapper')
    const $country = $wrapper.querySelector('#reg-form-country')
    const $vatWrapper = $wrapper.querySelector('#reg-form-vat-wrapper')
    const $vat = $wrapper.querySelector('#reg-form-vat')

    const fullWrapperHiddenClass = 'page-form__input-item--hidden'

    const $isEsFullWrapper = $wrapper.querySelector('#reg-form-is-ES-full-wrapper')
    const $vatFullWrapper = $wrapper.querySelector('#reg-form-vat-full-wrapper')
    const $countryFullWrapper = $wrapper.querySelector('#reg-form-country-full-wrapper')


    $isCompany.addEventListener('change', checkRequired)
    $isES.addEventListener('change', checkRequired)

    function checkRequired() {
        if ($isCompany.checked) {
            $isEsFullWrapper.classList.remove(fullWrapperHiddenClass)

            if ($isES.checked) {
                $vatWrapper.classList.add('form-check__field')
                $countryWrapper.classList.add('form-check__field')

                $vatFullWrapper.classList.remove(fullWrapperHiddenClass)
                $countryFullWrapper.classList.remove(fullWrapperHiddenClass)
            } else {
                $vatWrapper.classList.remove('form-check__field')
                $countryWrapper.classList.remove('form-check__field')

                $vatFullWrapper.classList.add(fullWrapperHiddenClass)
                $countryFullWrapper.classList.add(fullWrapperHiddenClass)
            }
        } else {
            $isEsFullWrapper.classList.add(fullWrapperHiddenClass)
            $vatFullWrapper.classList.add(fullWrapperHiddenClass)
            $countryFullWrapper.classList.add(fullWrapperHiddenClass)
            $vatWrapper.classList.remove('form-check__field')
            $countryWrapper.classList.remove('form-check__field')
        }

        formCheckHandlerObj.get('reg-form').refresh()
        formCheckHandlerObj.get('reg-form').validate_without_error()
    }


}



